var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "extend-feeds-live-extra-options" }, [
    _c(
      "div",
      { staticClass: "extend-feeds-live-extra-option" },
      [
        _c("div", { staticClass: "extend-feeds-live-extra-option-header" }, [
          _vm._v("置顶列表"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "extend-feeds-live-extra-option-description" },
          [
            _vm._v(
              "\n      配置直播信息扩充要展示的置顶列表，置顶列表中的用户会排序到上方。\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(_setup.FollowingListSelect, {
          attrs: { value: _setup.pinnedListID },
          on: { change: _setup.handlePinnedListChange },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extend-feeds-live-extra-option" },
      [
        _c("div", { staticClass: "extend-feeds-live-extra-option-header" }, [
          _vm._v("隐藏列表"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "extend-feeds-live-extra-option-description" },
          [
            _vm._v(
              "\n      配置直播信息扩充要展示的隐藏列表，隐藏列表中的用户会被隐藏，优先级高于置顶列表。\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(_setup.FollowingListSelect, {
          attrs: { value: _setup.hiddenListID },
          on: { change: _setup.handleHiddenListChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }